import { render, staticRenderFns } from "./editRepModal.vue?vue&type=template&id=28573662"
import script from "./editRepModal.vue?vue&type=script&lang=js"
export * from "./editRepModal.vue?vue&type=script&lang=js"
import style0 from "./editRepModal.vue?vue&type=style&index=0&id=28573662&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports